<template>
    <div>
        <!-- ACCOUNT INFORMATION -->
        <div class="w-100">
            <div class="row justify-content-between px-4">
                <h4 class="font-weight-bold mt-1 mb-1">Registered Account Information</h4>
                <button v-if="!isModal" class="btn btn-link btn-icon-color float-right" @click="openEditAccountInformation(true)">
                    <i class="fas fa-edit fa-lg"></i>
                </button>
            </div>
            <!-- ADDRESS DETAILS -->
            <div v-if="account.address" class="px-1">
                <p class="my-0">{{ account.address.addressLine1 }}</p>
                <p class="my-0">{{ account.address.addressLine2 }}</p>
                <p class="my-0">{{ account.address.postCode }}</p>
            </div>
            <p class="mb-0 mt-2 px-1">Account E-mail: {{ account.email }}</p>
        </div>

        <!-- EDIT ACCOUNT INFORMATION MODAL -->
        <edit-account-information v-if="isEditingAccountInformation" ref="editAccountInformation" @closeModal="openEditAccountInformation(false)" />
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import EditAccountInformation from "@/modals/EditAccountInformation.vue";

export default {
    mixins: [breakpoint],
    props: {
        account: Object,
        leadUser: Object,
        isModal: Boolean
    },
    components: {
        EditAccountInformation
    },
    data(){
        return {
            isEditingAccountInformation: false
        }
    },
    methods: {
        openEditAccountInformation: function(isOpening){
            if (isOpening){
                this.isEditingAccountInformation = true;
                setTimeout(() => {
                    let element = this.$refs.editAccountInformation.$el;
                    $(element).modal({backdrop: 'static', keyboard: false});
                }, 500);
            } else {
                this.isEditingAccountInformation = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>